import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiFileText, FiDatabase, FiActivity, FiUserCheck, FiAlertTriangle, FiUmbrella } = FiIcons;

const services = [
  { icon: FiFileText, title: "Governance, Risk, and Compliance (GRC)", desc: "Tackle complex regulations like ISO 27001, NIST, NIS2, and GDPR with ease. Our team ensures your organization is fully compliant, reducing risks while safeguarding your reputation." },
  { icon: FiDatabase, title: "Data & Privacy", desc: "Your data is your most valuable asset—and managing it securely is essential. We help you stay compliant with privacy laws like GDPR while ensuring your data is handled responsibly." },
  { icon: FiActivity, title: "Cybersecurity Audits", desc: "Don't let compliance frameworks slow you down. We perform in-depth audits and deliver clear recommendations, helping you seamlessly pass certifications for GDPR, ISO 27001, NIS2, DORA and more." },
  { icon: FiUserCheck, title: "Virtual CISO (vCISO)", desc: "Hiring a full-time CISO can be costly. That's why we offer virtual CISO (vCISO) services equipped with customized tools that simplify your path to compliance." },
  { icon: FiAlertTriangle, title: "Computer Security Incident Response Team (CSIRT)", desc: "When incidents strike, every moment matters. Our expert team is on standby to contain and resolve issues quickly, minimizing damage and ensuring your business stays on track." },
  { icon: FiUmbrella, title: "Covered by Cyber Insurance", desc: "We've got your budget covered! Many of our services are approved by cyber insurance providers, so you can strengthen your security while staying financially protected." },
];

export default function Services() {
  return (
    <section id="services" className="pt-24 pb-24 md:pt-32 md:pb-32 bg-[#0d0d0d] border-t border-[#222222]">
      <div className="container mx-auto px-8">
        <div className="text-center max-w-3xl mx-auto mb-16 md:mb-20">
          <h5 className="text-brand-orange font-bold tracking-widest uppercase text-sm mb-4">Services</h5>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-8">What We Do</h2>
          <div className="w-20 h-1 bg-brand-orange mx-auto rounded-full" />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="bg-[#1a1a1a] border border-[#2a2a2a] p-10 rounded-2xl hover:border-brand-orange/40 transition-colors duration-300 group"
            >
              <div className="w-16 h-16 rounded-2xl bg-brand-orange/10 border border-brand-orange/20 flex items-center justify-center mb-8 group-hover:bg-brand-orange/15 transition-colors duration-300">
                <SafeIcon icon={service.icon} className="text-3xl text-brand-orange" />
              </div>
              <h3 className="text-xl font-bold text-white mb-4">{service.title}</h3>
              <p className="text-gray-400 text-sm leading-relaxed">{service.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}